var _defs, _clipPath, _polygon, _path, _path2, _path3, _rect, _path4, _path5, _polygon2, _polygon3, _path6, _circle, _circle2, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscover(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 251.15 158.68",
    enableBackground: "new 0 0 251.15 158.68",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M242.646,158.68H8.504c-4.677,0-8.504-3.827-8.504-8.504V8.504C0,3.827,3.827,0,8.504,0h234.142 c4.677,0,8.504,3.827,8.504,8.504v141.672C251.15,154.853,247.323,158.68,242.646,158.68z"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_2_)",
    fill: "#FFFFFF",
    points: "-1.208,-1.149 252.327,-1.163 252.327,160.307 -1.172,160.312  "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#F48120",
    d: "M251.432,88.638c0,0-69.28,48.886-196.164,70.766h196.164V88.638z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    display: "none",
    clipPath: "url(#SVGID_2_)",
    fill: "#231F20",
    d: "M252.327-2.092L-2.105-2.067v163.306H253.25L253.235-2.092 H252.327z M251.406-0.241c0,1.811,0,157.806,0,159.627c-1.829,0-249.832,0-251.666,0c0-1.811-0.01-157.801-0.01-159.621 C1.569-0.235,249.557-0.241,251.406-0.241z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#231F20",
    d: "M20.224,47.886H9.644v36.951h10.524c5.596,0,9.637-1.32,13.184-4.266 c4.215-3.488,6.708-8.746,6.708-14.184C40.061,55.483,31.913,47.886,20.224,47.886z M28.644,75.644 c-2.265,2.045-5.206,2.937-9.863,2.937h-1.934V54.147h1.934c4.657,0,7.483,0.833,9.863,2.988c2.493,2.219,3.992,5.659,3.992,9.198 C32.636,69.881,31.137,73.426,28.644,75.644z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 43.377,
    y: 47.886,
    clipPath: "url(#SVGID_2_)",
    fill: "#231F20",
    width: 7.208,
    height: 36.951
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#231F20",
    d: "M68.209,62.066c-4.325-1.6-5.595-2.656-5.595-4.652 c0-2.328,2.263-4.096,5.369-4.096c2.16,0,3.934,0.887,5.812,2.992l3.771-4.938c-3.099-2.711-6.807-4.097-10.858-4.097 c-6.538,0-11.525,4.54-11.525,10.588c0,5.091,2.322,7.697,9.091,10.133c2.822,0.995,4.258,1.658,4.983,2.104 c1.44,0.94,2.161,2.272,2.161,3.823c0,2.994-2.38,5.212-5.596,5.212c-3.438,0-6.207-1.719-7.866-4.928L53.3,78.691 c3.321,4.874,7.309,7.035,12.793,7.035c7.49,0,12.744-4.98,12.744-12.133C78.837,67.722,76.408,65.064,68.209,62.066z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#231F20",
    d: "M81.111,66.387c0,10.861,8.529,19.283,19.504,19.283 c3.103,0,5.76-0.61,9.037-2.153v-8.485c-2.882,2.884-5.434,4.047-8.701,4.047c-7.259,0-12.411-5.263-12.411-12.746 c0-7.094,5.315-12.691,12.076-12.691c3.438,0,6.04,1.227,9.037,4.158v-8.481c-3.164-1.605-5.765-2.27-8.867-2.27 C89.865,47.051,81.111,55.644,81.111,66.387z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_2_)",
    fill: "#231F20",
    points: "166.799,72.706 156.945,47.886 149.071,47.886 164.753,85.785  168.631,85.785 184.594,47.886 176.781,47.886  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_2_)",
    fill: "#231F20",
    points: "187.853,84.837 208.294,84.837 208.294,78.582 195.055,78.582  195.055,68.608 207.806,68.608 207.806,62.349 195.055,62.349 195.055,54.147 208.294,54.147 208.294,47.886 187.853,47.886  "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#231F20",
    d: "M236.831,58.795c0-6.918-4.765-10.909-13.077-10.909h-10.687v36.951h7.199 V69.993h0.94l9.976,14.844h8.864L228.414,69.27C233.842,68.166,236.831,64.453,236.831,58.795z M222.372,64.898h-2.105V53.706 h2.219c4.489,0,6.929,1.881,6.929,5.477C229.415,62.898,226.975,64.898,222.372,64.898z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_2_)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MarkingBase"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 141.7237,
    y1: 76.4364,
    x2: 128.1133,
    y2: 97.7462,
    gradientTransform: "matrix(1 0 0 -1 0 158.68)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F89F20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2502,
    style: {
      stopColor: "#F79A20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5331,
    style: {
      stopColor: "#F68D20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6196,
    style: {
      stopColor: "#F58720"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7232,
    style: {
      stopColor: "#F48120"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F37521"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "url(#SVGID_3_)",
    cx: 131.662,
    cy: 66.49,
    r: 19.657
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 139.5737,
    y1: 76.7261,
    x2: 119.6818,
    y2: 115.606,
    gradientTransform: "matrix(1 0 0 -1 0 158.68)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F58720",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3587,
    style: {
      stopColor: "#E16F27",
      stopOpacity: 0.2704
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703,
    style: {
      stopColor: "#D4602C",
      stopOpacity: 0.5299
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    style: {
      stopColor: "#D05B2E",
      stopOpacity: 0.74
    }
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.65,
    fill: "url(#SVGID_4_)",
    enableBackground: "new    ",
    cx: 131.662,
    cy: 66.49,
    r: 19.657
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mark",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MarkingCover",
    display: "inline",
    opacity: 0.5,
    enableBackground: "new    "
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_5_",
    opacity: 0.5,
    enableBackground: "new    ",
    cx: 131.659,
    cy: 66.495,
    r: 19.657
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    id: "BlendGroup",
    clipPath: "url(#SVGID_6_)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "BlendBottom",
    fill: "#231F20",
    cx: 131.723,
    cy: 66.556,
    r: 20.053
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#242021",
    cx: 131.734,
    cy: 66.569,
    r: 20.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#252122",
    cx: 131.745,
    cy: 66.581,
    r: 20.049
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#252223",
    cx: 131.756,
    cy: 66.594,
    r: 20.047
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#262223",
    cx: 131.767,
    cy: 66.606,
    r: 20.045
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#272324",
    cx: 131.777,
    cy: 66.619,
    r: 20.043
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#282425",
    cx: 131.788,
    cy: 66.631,
    r: 20.041
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#292526",
    cx: 131.799,
    cy: 66.644,
    r: 20.039
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#292627",
    cx: 131.81,
    cy: 66.657,
    r: 20.037
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2A2728",
    cx: 131.821,
    cy: 66.669,
    r: 20.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2B2728",
    cx: 131.832,
    cy: 66.682,
    r: 20.033
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2C2829",
    cx: 131.843,
    cy: 66.694,
    r: 20.031
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2D292A",
    cx: 131.853,
    cy: 66.707,
    r: 20.029
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2D2A2B",
    cx: 131.864,
    cy: 66.719,
    r: 20.027
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2E2B2C",
    cx: 131.875,
    cy: 66.732,
    r: 20.025
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2F2C2D",
    cx: 131.886,
    cy: 66.744,
    r: 20.023
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#302C2D",
    cx: 131.897,
    cy: 66.757,
    r: 20.021
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#312D2E",
    cx: 131.908,
    cy: 66.769,
    r: 20.019
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#322E2F",
    cx: 131.919,
    cy: 66.782,
    r: 20.017
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#322F30",
    cx: 131.93,
    cy: 66.794,
    r: 20.016
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#333031",
    cx: 131.94,
    cy: 66.807,
    r: 20.014
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#343132",
    cx: 131.951,
    cy: 66.819,
    r: 20.012
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#353132",
    cx: 131.962,
    cy: 66.832,
    r: 20.01
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#363233",
    cx: 131.973,
    cy: 66.844,
    r: 20.008
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#363334",
    cx: 131.984,
    cy: 66.857,
    r: 20.006
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#373435",
    cx: 131.995,
    cy: 66.869,
    r: 20.004
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#383536",
    cx: 132.006,
    cy: 66.882,
    r: 20.002
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#393637",
    cx: 132.016,
    cy: 66.894,
    r: 20
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3A3638",
    cx: 132.027,
    cy: 66.907,
    r: 19.998
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3A3738",
    cx: 132.038,
    cy: 66.919,
    r: 19.996
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3B3839",
    cx: 132.049,
    cy: 66.932,
    r: 19.994
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3C393A",
    cx: 132.06,
    cy: 66.945,
    r: 19.992
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3D3A3B",
    cx: 132.071,
    cy: 66.957,
    r: 19.99
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3E3B3C",
    cx: 132.082,
    cy: 66.97,
    r: 19.988
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3E3B3D",
    cx: 132.092,
    cy: 66.982,
    r: 19.986
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3F3C3D",
    cx: 132.103,
    cy: 66.995,
    r: 19.984
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#403D3E",
    cx: 132.114,
    cy: 67.007,
    r: 19.982
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#413E3F",
    cx: 132.125,
    cy: 67.02,
    r: 19.98
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#423F40",
    cx: 132.136,
    cy: 67.032,
    r: 19.978
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#424041",
    cx: 132.147,
    cy: 67.045,
    r: 19.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#434042",
    cx: 132.158,
    cy: 67.057,
    r: 19.974
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#444142",
    cx: 132.168,
    cy: 67.07,
    r: 19.972
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#454243",
    cx: 132.179,
    cy: 67.082,
    r: 19.971
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#464344",
    cx: 132.19,
    cy: 67.095,
    r: 19.969
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#464445",
    cx: 132.201,
    cy: 67.107,
    r: 19.967
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#474546",
    cx: 132.212,
    cy: 67.12,
    r: 19.965
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#484547",
    cx: 132.223,
    cy: 67.132,
    r: 19.963
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#494648",
    cx: 132.234,
    cy: 67.145,
    r: 19.961
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4A4748",
    cx: 132.245,
    cy: 67.157,
    r: 19.959
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4A4849",
    cx: 132.255,
    cy: 67.17,
    r: 19.957
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4B494A",
    cx: 132.266,
    cy: 67.182,
    r: 19.955
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4C4A4B",
    cx: 132.277,
    cy: 67.195,
    r: 19.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4D4A4C",
    cx: 132.288,
    cy: 67.208,
    r: 19.951
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4E4B4D",
    cx: 132.299,
    cy: 67.22,
    r: 19.949
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4F4C4D",
    cx: 132.31,
    cy: 67.233,
    r: 19.947
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4F4D4E",
    cx: 132.321,
    cy: 67.245,
    r: 19.945
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#504E4F",
    cx: 132.331,
    cy: 67.258,
    r: 19.943
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#514F50",
    cx: 132.342,
    cy: 67.27,
    r: 19.941
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#524F51",
    cx: 132.353,
    cy: 67.283,
    r: 19.939
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#535052",
    cx: 132.364,
    cy: 67.295,
    r: 19.937
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#535152",
    cx: 132.375,
    cy: 67.308,
    r: 19.935
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#545253",
    cx: 132.386,
    cy: 67.32,
    r: 19.933
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#555354",
    cx: 132.397,
    cy: 67.333,
    r: 19.931
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#565455",
    cx: 132.407,
    cy: 67.345,
    r: 19.929
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#575456",
    cx: 132.418,
    cy: 67.358,
    r: 19.927
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#575557",
    cx: 132.429,
    cy: 67.37,
    r: 19.926
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#585657",
    cx: 132.44,
    cy: 67.383,
    r: 19.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#595758",
    cx: 132.451,
    cy: 67.395,
    r: 19.922
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5A5859",
    cx: 132.462,
    cy: 67.408,
    r: 19.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5B595A",
    cx: 132.473,
    cy: 67.42,
    r: 19.918
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5B5A5B",
    cx: 132.483,
    cy: 67.433,
    r: 19.916
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5C5A5C",
    cx: 132.494,
    cy: 67.445,
    r: 19.914
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5D5B5D",
    cx: 132.505,
    cy: 67.458,
    r: 19.912
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5E5C5D",
    cx: 132.516,
    cy: 67.47,
    r: 19.91
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5F5D5E",
    cx: 132.527,
    cy: 67.483,
    r: 19.908
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5F5E5F",
    cx: 132.538,
    cy: 67.496,
    r: 19.906
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#605F60",
    cx: 132.549,
    cy: 67.508,
    r: 19.904
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#615F61",
    cx: 132.56,
    cy: 67.521,
    r: 19.902
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#626062",
    cx: 132.57,
    cy: 67.533,
    r: 19.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#636162",
    cx: 132.581,
    cy: 67.546,
    r: 19.898
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#636263",
    cx: 132.592,
    cy: 67.558,
    r: 19.896
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#646364",
    cx: 132.603,
    cy: 67.571,
    r: 19.894
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#656465",
    cx: 132.614,
    cy: 67.583,
    r: 19.892
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#666466",
    cx: 132.625,
    cy: 67.596,
    r: 19.89
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#676567",
    cx: 132.636,
    cy: 67.608,
    r: 19.888
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#686667",
    cx: 132.646,
    cy: 67.621,
    r: 19.886
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#686768",
    cx: 132.657,
    cy: 67.633,
    r: 19.884
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#696869",
    cx: 132.668,
    cy: 67.646,
    r: 19.882
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6A696A",
    cx: 132.679,
    cy: 67.658,
    r: 19.88
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6B696B",
    cx: 132.69,
    cy: 67.671,
    r: 19.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6C6A6C",
    cx: 132.701,
    cy: 67.683,
    r: 19.877
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6C6B6D",
    cx: 132.712,
    cy: 67.696,
    r: 19.875
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6D6C6D",
    cx: 132.722,
    cy: 67.708,
    r: 19.873
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6E6D6E",
    cx: 132.733,
    cy: 67.721,
    r: 19.871
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6F6E6F",
    cx: 132.744,
    cy: 67.733,
    r: 19.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#706E70",
    cx: 132.755,
    cy: 67.746,
    r: 19.867
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#706F71",
    cx: 132.766,
    cy: 67.759,
    r: 19.865
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#717072",
    cx: 132.777,
    cy: 67.771,
    r: 19.863
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#727172",
    cx: 132.788,
    cy: 67.784,
    r: 19.861
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#737273",
    cx: 132.798,
    cy: 67.796,
    r: 19.859
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#747374",
    cx: 132.809,
    cy: 67.809,
    r: 19.857
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#747375",
    cx: 132.82,
    cy: 67.821,
    r: 19.855
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#757476",
    cx: 132.831,
    cy: 67.834,
    r: 19.853
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#767577",
    cx: 132.842,
    cy: 67.846,
    r: 19.851
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#777677",
    cx: 132.853,
    cy: 67.859,
    r: 19.849
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#787778",
    cx: 132.864,
    cy: 67.871,
    r: 19.847
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#787879",
    cx: 132.875,
    cy: 67.884,
    r: 19.845
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#79787A",
    cx: 132.885,
    cy: 67.896,
    r: 19.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7A797B",
    cx: 132.896,
    cy: 67.909,
    r: 19.841
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7B7A7C",
    cx: 132.907,
    cy: 67.921,
    r: 19.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7C7B7C",
    cx: 132.918,
    cy: 67.934,
    r: 19.837
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7C7C7D",
    cx: 132.929,
    cy: 67.946,
    r: 19.835
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7D7D7E",
    cx: 132.94,
    cy: 67.959,
    r: 19.834
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7E7D7F",
    cx: 132.951,
    cy: 67.971,
    r: 19.832
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7F7E80",
    cx: 132.961,
    cy: 67.984,
    r: 19.83
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#807F81",
    cx: 132.972,
    cy: 67.996,
    r: 19.828
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#808082",
    cx: 132.983,
    cy: 68.009,
    r: 19.826
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#818182",
    cx: 132.994,
    cy: 68.021,
    r: 19.824
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#828283",
    cx: 133.005,
    cy: 68.034,
    r: 19.822
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#838284",
    cx: 133.016,
    cy: 68.047,
    r: 19.82
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#848385",
    cx: 133.027,
    cy: 68.059,
    r: 19.818
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#858486",
    cx: 133.037,
    cy: 68.072,
    r: 19.816
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#858587",
    cx: 133.048,
    cy: 68.084,
    r: 19.814
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#868687",
    cx: 133.059,
    cy: 68.097,
    r: 19.812
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878788",
    cx: 133.07,
    cy: 68.109,
    r: 19.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#888789",
    cx: 133.081,
    cy: 68.122,
    r: 19.808
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#89888A",
    cx: 133.092,
    cy: 68.134,
    r: 19.806
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#89898B",
    cx: 133.103,
    cy: 68.147,
    r: 19.804
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8A8A8C",
    cx: 133.114,
    cy: 68.159,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8B8B8C",
    cx: 133.124,
    cy: 68.172,
    r: 19.8
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8C8C8D",
    cx: 133.135,
    cy: 68.184,
    r: 19.798
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8D8C8E",
    cx: 133.146,
    cy: 68.197,
    r: 19.796
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8D8D8F",
    cx: 133.157,
    cy: 68.209,
    r: 19.794
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8E8E90",
    cx: 133.168,
    cy: 68.222,
    r: 19.792
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8F8F91",
    cx: 133.179,
    cy: 68.234,
    r: 19.79
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#909092",
    cx: 133.19,
    cy: 68.247,
    r: 19.789
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#919192",
    cx: 133.2,
    cy: 68.259,
    r: 19.787
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#919293",
    cx: 133.211,
    cy: 68.272,
    r: 19.785
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#929294",
    cx: 133.222,
    cy: 68.284,
    r: 19.783
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#939395",
    cx: 133.233,
    cy: 68.297,
    r: 19.781
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#949496",
    cx: 133.244,
    cy: 68.31,
    r: 19.779
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#959597",
    cx: 133.255,
    cy: 68.322,
    r: 19.777
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#959697",
    cx: 133.266,
    cy: 68.335,
    r: 19.775
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#969798",
    cx: 133.276,
    cy: 68.347,
    r: 19.773
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#979799",
    cx: 133.287,
    cy: 68.36,
    r: 19.771
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#98989A",
    cx: 133.298,
    cy: 68.372,
    r: 19.769
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#99999B",
    cx: 133.309,
    cy: 68.385,
    r: 19.767
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#999A9C",
    cx: 133.32,
    cy: 68.397,
    r: 19.765
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9A9B9C",
    cx: 133.331,
    cy: 68.41,
    r: 19.763
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9B9C9D",
    cx: 133.342,
    cy: 68.422,
    r: 19.761
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9C9C9E",
    cx: 133.352,
    cy: 68.435,
    r: 19.759
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9D9D9F",
    cx: 133.363,
    cy: 68.447,
    r: 19.757
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9E9EA0",
    cx: 133.374,
    cy: 68.46,
    r: 19.755
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9E9FA1",
    cx: 133.385,
    cy: 68.472,
    r: 19.753
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9FA0A1",
    cx: 133.396,
    cy: 68.485,
    r: 19.751
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A0A1A2",
    cx: 133.407,
    cy: 68.497,
    r: 19.749
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A1A1A3",
    cx: 133.418,
    cy: 68.51,
    r: 19.747
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A2A2A4",
    cx: 133.429,
    cy: 68.522,
    r: 19.745
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A2A3A5",
    cx: 133.439,
    cy: 68.535,
    r: 19.744
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A3A4A6",
    cx: 133.45,
    cy: 68.547,
    r: 19.742
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A4A5A7",
    cx: 133.461,
    cy: 68.56,
    r: 19.74
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A5A6A7",
    cx: 133.472,
    cy: 68.572,
    r: 19.738
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A6A6A8",
    cx: 133.483,
    cy: 68.585,
    r: 19.736
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A6A7A9",
    cx: 133.494,
    cy: 68.598,
    r: 19.734
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A7A8AA",
    cx: 133.505,
    cy: 68.61,
    r: 19.732
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A8A9AB",
    cx: 133.515,
    cy: 68.623,
    r: 19.73
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A9AAAC",
    cx: 133.526,
    cy: 68.635,
    r: 19.728
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AAABAC",
    cx: 133.537,
    cy: 68.648,
    r: 19.726
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AAABAD",
    cx: 133.548,
    cy: 68.66,
    r: 19.724
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ABACAE",
    cx: 133.559,
    cy: 68.673,
    r: 19.722
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ACADAF",
    cx: 133.57,
    cy: 68.685,
    r: 19.72
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ADAEB0",
    cx: 133.581,
    cy: 68.698,
    r: 19.718
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AEAFB1",
    cx: 133.591,
    cy: 68.71,
    r: 19.716
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AEB0B1",
    cx: 133.602,
    cy: 68.723,
    r: 19.714
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AFB0B2",
    cx: 133.613,
    cy: 68.735,
    r: 19.712
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B0B1B3",
    cx: 133.624,
    cy: 68.748,
    r: 19.71
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B1B2B4",
    cx: 133.635,
    cy: 68.76,
    r: 19.708
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B2B3B5",
    cx: 133.646,
    cy: 68.773,
    r: 19.706
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B2B4B6",
    cx: 133.657,
    cy: 68.785,
    r: 19.704
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B3B5B7",
    cx: 133.667,
    cy: 68.798,
    r: 19.702
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B4B5B7",
    cx: 133.678,
    cy: 68.81,
    r: 19.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B5B6B8",
    cx: 133.689,
    cy: 68.823,
    r: 19.699
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B6B7B9",
    cx: 133.7,
    cy: 68.835,
    r: 19.697
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B6B8BA",
    cx: 133.711,
    cy: 68.848,
    r: 19.695
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B7B9BB",
    cx: 133.722,
    cy: 68.861,
    r: 19.693
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B8BABC",
    cx: 133.733,
    cy: 68.873,
    r: 19.691
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B9BABC",
    cx: 133.744,
    cy: 68.886,
    r: 19.689
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BABBBD",
    cx: 133.754,
    cy: 68.898,
    r: 19.687
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BBBCBE",
    cx: 133.765,
    cy: 68.911,
    r: 19.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BBBDBF",
    cx: 133.776,
    cy: 68.923,
    r: 19.683
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BCBEC0",
    cx: 133.787,
    cy: 68.936,
    r: 19.681
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BDBFC1",
    cx: 133.798,
    cy: 68.948,
    r: 19.679
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BEBFC1",
    cx: 133.809,
    cy: 68.961,
    r: 19.677
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BFC0C2",
    cx: 133.82,
    cy: 68.973,
    r: 19.675
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BFC1C3",
    cx: 133.83,
    cy: 68.986,
    r: 19.673
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C0C2C4",
    cx: 133.841,
    cy: 68.998,
    r: 19.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C1C3C5",
    cx: 133.852,
    cy: 69.011,
    r: 19.669
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C2C4C6",
    cx: 133.863,
    cy: 69.023,
    r: 19.667
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C3C4C6",
    cx: 133.874,
    cy: 69.036,
    r: 19.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C3C5C7",
    cx: 133.885,
    cy: 69.048,
    r: 19.663
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C4C6C8",
    cx: 133.896,
    cy: 69.061,
    r: 19.661
  }), /*#__PURE__*/React.createElement("circle", {
    id: "BlendMiddle",
    fill: "#C5C7C9",
    cx: 133.906,
    cy: 69.073,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.995,
    fill: "#C5C7C9",
    enableBackground: "new    ",
    cx: 133.916,
    cy: 69.085,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.99,
    fill: "#C6C8CA",
    enableBackground: "new    ",
    cx: 133.925,
    cy: 69.096,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.9851,
    fill: "#C6C8CA",
    enableBackground: "new    ",
    cx: 133.935,
    cy: 69.107,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.9801,
    fill: "#C6C8CA",
    enableBackground: "new    ",
    cx: 133.944,
    cy: 69.119,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.9751,
    fill: "#C6C8CA",
    enableBackground: "new    ",
    cx: 133.953,
    cy: 69.13,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.9701,
    fill: "#C7C9CB",
    enableBackground: "new    ",
    cx: 133.963,
    cy: 69.141,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.9652,
    fill: "#C7C9CB",
    enableBackground: "new    ",
    cx: 133.972,
    cy: 69.153,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.9602,
    fill: "#C7C9CB",
    enableBackground: "new    ",
    cx: 133.982,
    cy: 69.164,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.9552,
    fill: "#C8CACB",
    enableBackground: "new    ",
    cx: 133.991,
    cy: 69.175,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.9502,
    fill: "#C8CACC",
    enableBackground: "new    ",
    cx: 134,
    cy: 69.187,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.9453,
    fill: "#C8CACC",
    enableBackground: "new    ",
    cx: 134.01,
    cy: 69.198,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.9403,
    fill: "#C8CACC",
    enableBackground: "new    ",
    cx: 134.019,
    cy: 69.209,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.9353,
    fill: "#C9CBCC",
    enableBackground: "new    ",
    cx: 134.028,
    cy: 69.221,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.9303,
    fill: "#C9CBCD",
    enableBackground: "new    ",
    cx: 134.038,
    cy: 69.232,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.9254,
    fill: "#C9CBCD",
    enableBackground: "new    ",
    cx: 134.047,
    cy: 69.243,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.9204,
    fill: "#CACBCD",
    enableBackground: "new    ",
    cx: 134.057,
    cy: 69.254,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.9154,
    fill: "#CACCCE",
    enableBackground: "new    ",
    cx: 134.066,
    cy: 69.266,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.9104,
    fill: "#CACCCE",
    enableBackground: "new    ",
    cx: 134.075,
    cy: 69.277,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.9055,
    fill: "#CACCCE",
    enableBackground: "new    ",
    cx: 134.085,
    cy: 69.288,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.9005,
    fill: "#CBCDCE",
    enableBackground: "new    ",
    cx: 134.094,
    cy: 69.3,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8955,
    fill: "#CBCDCF",
    enableBackground: "new    ",
    cx: 134.104,
    cy: 69.311,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8905,
    fill: "#CBCDCF",
    enableBackground: "new    ",
    cx: 134.113,
    cy: 69.322,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8856,
    fill: "#CCCDCF",
    enableBackground: "new    ",
    cx: 134.122,
    cy: 69.334,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8806,
    fill: "#CCCECF",
    enableBackground: "new    ",
    cx: 134.132,
    cy: 69.345,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8756,
    fill: "#CCCED0",
    enableBackground: "new    ",
    cx: 134.141,
    cy: 69.356,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8706,
    fill: "#CDCED0",
    enableBackground: "new    ",
    cx: 134.15,
    cy: 69.368,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8657,
    fill: "#CDCFD0",
    enableBackground: "new    ",
    cx: 134.16,
    cy: 69.379,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8607,
    fill: "#CDCFD1",
    enableBackground: "new    ",
    cx: 134.169,
    cy: 69.39,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8557,
    fill: "#CDCFD1",
    enableBackground: "new    ",
    cx: 134.179,
    cy: 69.402,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8507,
    fill: "#CECFD1",
    enableBackground: "new    ",
    cx: 134.188,
    cy: 69.413,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8458,
    fill: "#CED0D1",
    enableBackground: "new    ",
    cx: 134.197,
    cy: 69.424,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8408,
    fill: "#CED0D2",
    enableBackground: "new    ",
    cx: 134.207,
    cy: 69.436,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8358,
    fill: "#CFD0D2",
    enableBackground: "new    ",
    cx: 134.216,
    cy: 69.447,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8308,
    fill: "#CFD0D2",
    enableBackground: "new    ",
    cx: 134.226,
    cy: 69.458,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8259,
    fill: "#CFD1D2",
    enableBackground: "new    ",
    cx: 134.235,
    cy: 69.469,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8209,
    fill: "#CFD1D3",
    enableBackground: "new    ",
    cx: 134.244,
    cy: 69.481,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8159,
    fill: "#D0D1D3",
    enableBackground: "new    ",
    cx: 134.254,
    cy: 69.492,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8109,
    fill: "#D0D2D3",
    enableBackground: "new    ",
    cx: 134.263,
    cy: 69.503,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.806,
    fill: "#D0D2D3",
    enableBackground: "new    ",
    cx: 134.272,
    cy: 69.515,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.801,
    fill: "#D1D2D4",
    enableBackground: "new    ",
    cx: 134.282,
    cy: 69.526,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.796,
    fill: "#D1D2D4",
    enableBackground: "new    ",
    cx: 134.291,
    cy: 69.537,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.791,
    fill: "#D1D3D4",
    enableBackground: "new    ",
    cx: 134.301,
    cy: 69.549,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7861,
    fill: "#D1D3D5",
    enableBackground: "new    ",
    cx: 134.31,
    cy: 69.56,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7811,
    fill: "#D2D3D5",
    enableBackground: "new    ",
    cx: 134.319,
    cy: 69.571,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7761,
    fill: "#D2D4D5",
    enableBackground: "new    ",
    cx: 134.329,
    cy: 69.583,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7711,
    fill: "#D2D4D5",
    enableBackground: "new    ",
    cx: 134.338,
    cy: 69.594,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7662,
    fill: "#D3D4D6",
    enableBackground: "new    ",
    cx: 134.348,
    cy: 69.605,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7612,
    fill: "#D3D4D6",
    enableBackground: "new    ",
    cx: 134.357,
    cy: 69.617,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7562,
    fill: "#D3D5D6",
    enableBackground: "new    ",
    cx: 134.366,
    cy: 69.628,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7512,
    fill: "#D3D5D6",
    enableBackground: "new    ",
    cx: 134.376,
    cy: 69.639,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7463,
    fill: "#D4D5D7",
    enableBackground: "new    ",
    cx: 134.385,
    cy: 69.65,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7413,
    fill: "#D4D5D7",
    enableBackground: "new    ",
    cx: 134.394,
    cy: 69.662,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7363,
    fill: "#D4D6D7",
    enableBackground: "new    ",
    cx: 134.404,
    cy: 69.673,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7313,
    fill: "#D5D6D8",
    enableBackground: "new    ",
    cx: 134.413,
    cy: 69.684,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7264,
    fill: "#D5D6D8",
    enableBackground: "new    ",
    cx: 134.423,
    cy: 69.696,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7214,
    fill: "#D5D7D8",
    enableBackground: "new    ",
    cx: 134.432,
    cy: 69.707,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7164,
    fill: "#D5D7D8",
    enableBackground: "new    ",
    cx: 134.441,
    cy: 69.718,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7114,
    fill: "#D6D7D9",
    enableBackground: "new    ",
    cx: 134.451,
    cy: 69.73,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7065,
    fill: "#D6D7D9",
    enableBackground: "new    ",
    cx: 134.46,
    cy: 69.741,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7015,
    fill: "#D6D8D9",
    enableBackground: "new    ",
    cx: 134.47,
    cy: 69.752,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6965,
    fill: "#D7D8D9",
    enableBackground: "new    ",
    cx: 134.479,
    cy: 69.764,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6915,
    fill: "#D7D8DA",
    enableBackground: "new    ",
    cx: 134.488,
    cy: 69.775,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6866,
    fill: "#D7D9DA",
    enableBackground: "new    ",
    cx: 134.498,
    cy: 69.786,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6816,
    fill: "#D7D9DA",
    enableBackground: "new    ",
    cx: 134.507,
    cy: 69.798,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6766,
    fill: "#D8D9DA",
    enableBackground: "new    ",
    cx: 134.516,
    cy: 69.809,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6716,
    fill: "#D8D9DB",
    enableBackground: "new    ",
    cx: 134.526,
    cy: 69.82,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6667,
    fill: "#D8DADB",
    enableBackground: "new    ",
    cx: 134.535,
    cy: 69.832,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6617,
    fill: "#D9DADB",
    enableBackground: "new    ",
    cx: 134.545,
    cy: 69.843,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6567,
    fill: "#D9DADC",
    enableBackground: "new    ",
    cx: 134.554,
    cy: 69.854,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6517,
    fill: "#D9DBDC",
    enableBackground: "new    ",
    cx: 134.563,
    cy: 69.865,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6468,
    fill: "#D9DBDC",
    enableBackground: "new    ",
    cx: 134.573,
    cy: 69.877,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6418,
    fill: "#DADBDC",
    enableBackground: "new    ",
    cx: 134.582,
    cy: 69.888,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6368,
    fill: "#DADBDD",
    enableBackground: "new    ",
    cx: 134.591,
    cy: 69.899,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6318,
    fill: "#DADCDD",
    enableBackground: "new    ",
    cx: 134.601,
    cy: 69.911,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6269,
    fill: "#DBDCDD",
    enableBackground: "new    ",
    cx: 134.61,
    cy: 69.922,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6219,
    fill: "#DBDCDD",
    enableBackground: "new    ",
    cx: 134.62,
    cy: 69.933,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6169,
    fill: "#DBDCDE",
    enableBackground: "new    ",
    cx: 134.629,
    cy: 69.945,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6119,
    fill: "#DCDDDE",
    enableBackground: "new    ",
    cx: 134.638,
    cy: 69.956,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.607,
    fill: "#DCDDDE",
    enableBackground: "new    ",
    cx: 134.648,
    cy: 69.967,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.602,
    fill: "#DCDDDE",
    enableBackground: "new    ",
    cx: 134.657,
    cy: 69.979,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.597,
    fill: "#DCDEDF",
    enableBackground: "new    ",
    cx: 134.667,
    cy: 69.99,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.592,
    fill: "#DDDEDF",
    enableBackground: "new    ",
    cx: 134.676,
    cy: 70.001,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5871,
    fill: "#DDDEDF",
    enableBackground: "new    ",
    cx: 134.685,
    cy: 70.013,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5821,
    fill: "#DDDEE0",
    enableBackground: "new    ",
    cx: 134.695,
    cy: 70.024,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5771,
    fill: "#DEDFE0",
    enableBackground: "new    ",
    cx: 134.704,
    cy: 70.035,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5721,
    fill: "#DEDFE0",
    enableBackground: "new    ",
    cx: 134.713,
    cy: 70.047,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5672,
    fill: "#DEDFE0",
    enableBackground: "new    ",
    cx: 134.723,
    cy: 70.058,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5622,
    fill: "#DEE0E1",
    enableBackground: "new    ",
    cx: 134.732,
    cy: 70.069,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5572,
    fill: "#DFE0E1",
    enableBackground: "new    ",
    cx: 134.742,
    cy: 70.08,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5522,
    fill: "#DFE0E1",
    enableBackground: "new    ",
    cx: 134.751,
    cy: 70.092,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5473,
    fill: "#DFE0E1",
    enableBackground: "new    ",
    cx: 134.76,
    cy: 70.103,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5423,
    fill: "#E0E1E2",
    enableBackground: "new    ",
    cx: 134.77,
    cy: 70.114,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5373,
    fill: "#E0E1E2",
    enableBackground: "new    ",
    cx: 134.779,
    cy: 70.126,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5323,
    fill: "#E0E1E2",
    enableBackground: "new    ",
    cx: 134.789,
    cy: 70.137,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5274,
    fill: "#E0E1E3",
    enableBackground: "new    ",
    cx: 134.798,
    cy: 70.148,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5224,
    fill: "#E1E2E3",
    enableBackground: "new    ",
    cx: 134.807,
    cy: 70.16,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5174,
    fill: "#E1E2E3",
    enableBackground: "new    ",
    cx: 134.817,
    cy: 70.171,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5124,
    fill: "#E1E2E3",
    enableBackground: "new    ",
    cx: 134.826,
    cy: 70.182,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5075,
    fill: "#E2E3E4",
    enableBackground: "new    ",
    cx: 134.835,
    cy: 70.194,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5025,
    fill: "#E2E3E4",
    enableBackground: "new    ",
    cx: 134.845,
    cy: 70.205,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4975,
    fill: "#E2E3E4",
    enableBackground: "new    ",
    cx: 134.854,
    cy: 70.216,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4925,
    fill: "#E2E3E4",
    enableBackground: "new    ",
    cx: 134.864,
    cy: 70.228,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4876,
    fill: "#E3E4E5",
    enableBackground: "new    ",
    cx: 134.873,
    cy: 70.239,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4826,
    fill: "#E3E4E5",
    enableBackground: "new    ",
    cx: 134.882,
    cy: 70.25,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4776,
    fill: "#E3E4E5",
    enableBackground: "new    ",
    cx: 134.892,
    cy: 70.262,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4726,
    fill: "#E4E5E5",
    enableBackground: "new    ",
    cx: 134.901,
    cy: 70.273,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4677,
    fill: "#E4E5E6",
    enableBackground: "new    ",
    cx: 134.911,
    cy: 70.284,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4627,
    fill: "#E4E5E6",
    enableBackground: "new    ",
    cx: 134.92,
    cy: 70.295,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4577,
    fill: "#E4E5E6",
    enableBackground: "new    ",
    cx: 134.929,
    cy: 70.307,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4527,
    fill: "#E5E6E7",
    enableBackground: "new    ",
    cx: 134.939,
    cy: 70.318,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4478,
    fill: "#E5E6E7",
    enableBackground: "new    ",
    cx: 134.948,
    cy: 70.329,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4428,
    fill: "#E5E6E7",
    enableBackground: "new    ",
    cx: 134.957,
    cy: 70.341,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4378,
    fill: "#E6E6E7",
    enableBackground: "new    ",
    cx: 134.967,
    cy: 70.352,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4328,
    fill: "#E6E7E8",
    enableBackground: "new    ",
    cx: 134.976,
    cy: 70.363,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4279,
    fill: "#E6E7E8",
    enableBackground: "new    ",
    cx: 134.986,
    cy: 70.375,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4229,
    fill: "#E6E7E8",
    enableBackground: "new    ",
    cx: 134.995,
    cy: 70.386,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4179,
    fill: "#E7E8E8",
    enableBackground: "new    ",
    cx: 135.004,
    cy: 70.397,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4129,
    fill: "#E7E8E9",
    enableBackground: "new    ",
    cx: 135.014,
    cy: 70.409,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.408,
    fill: "#E7E8E9",
    enableBackground: "new    ",
    cx: 135.023,
    cy: 70.42,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.403,
    fill: "#E8E8E9",
    enableBackground: "new    ",
    cx: 135.033,
    cy: 70.431,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.398,
    fill: "#E8E9EA",
    enableBackground: "new    ",
    cx: 135.042,
    cy: 70.443,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.393,
    fill: "#E8E9EA",
    enableBackground: "new    ",
    cx: 135.051,
    cy: 70.454,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3881,
    fill: "#E8E9EA",
    enableBackground: "new    ",
    cx: 135.061,
    cy: 70.465,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3831,
    fill: "#E9EAEA",
    enableBackground: "new    ",
    cx: 135.07,
    cy: 70.477,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3781,
    fill: "#E9EAEB",
    enableBackground: "new    ",
    cx: 135.079,
    cy: 70.488,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3731,
    fill: "#E9EAEB",
    enableBackground: "new    ",
    cx: 135.089,
    cy: 70.499,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3682,
    fill: "#EAEAEB",
    enableBackground: "new    ",
    cx: 135.098,
    cy: 70.51,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3632,
    fill: "#EAEBEB",
    enableBackground: "new    ",
    cx: 135.108,
    cy: 70.522,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3582,
    fill: "#EAEBEC",
    enableBackground: "new    ",
    cx: 135.117,
    cy: 70.533,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3532,
    fill: "#EBEBEC",
    enableBackground: "new    ",
    cx: 135.126,
    cy: 70.544,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3483,
    fill: "#EBEBEC",
    enableBackground: "new    ",
    cx: 135.136,
    cy: 70.556,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3433,
    fill: "#EBECEC",
    enableBackground: "new    ",
    cx: 135.145,
    cy: 70.567,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3383,
    fill: "#EBECED",
    enableBackground: "new    ",
    cx: 135.155,
    cy: 70.578,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3333,
    fill: "#ECECED",
    enableBackground: "new    ",
    cx: 135.164,
    cy: 70.59,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3284,
    fill: "#ECEDED",
    enableBackground: "new    ",
    cx: 135.173,
    cy: 70.601,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3234,
    fill: "#ECEDEE",
    enableBackground: "new    ",
    cx: 135.183,
    cy: 70.612,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3184,
    fill: "#EDEDEE",
    enableBackground: "new    ",
    cx: 135.192,
    cy: 70.624,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3134,
    fill: "#EDEDEE",
    enableBackground: "new    ",
    cx: 135.201,
    cy: 70.635,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3085,
    fill: "#EDEEEE",
    enableBackground: "new    ",
    cx: 135.211,
    cy: 70.646,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3035,
    fill: "#EDEEEF",
    enableBackground: "new    ",
    cx: 135.22,
    cy: 70.658,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2985,
    fill: "#EEEEEF",
    enableBackground: "new    ",
    cx: 135.23,
    cy: 70.669,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2935,
    fill: "#EEEFEF",
    enableBackground: "new    ",
    cx: 135.239,
    cy: 70.68,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2886,
    fill: "#EEEFEF",
    enableBackground: "new    ",
    cx: 135.248,
    cy: 70.692,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2836,
    fill: "#EFEFF0",
    enableBackground: "new    ",
    cx: 135.258,
    cy: 70.703,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2786,
    fill: "#EFEFF0",
    enableBackground: "new    ",
    cx: 135.267,
    cy: 70.714,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2736,
    fill: "#EFF0F0",
    enableBackground: "new    ",
    cx: 135.277,
    cy: 70.725,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2687,
    fill: "#EFF0F0",
    enableBackground: "new    ",
    cx: 135.286,
    cy: 70.737,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2637,
    fill: "#F0F0F1",
    enableBackground: "new    ",
    cx: 135.295,
    cy: 70.748,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2587,
    fill: "#F0F1F1",
    enableBackground: "new    ",
    cx: 135.305,
    cy: 70.759,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2537,
    fill: "#F0F1F1",
    enableBackground: "new    ",
    cx: 135.314,
    cy: 70.771,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2488,
    fill: "#F1F1F2",
    enableBackground: "new    ",
    cx: 135.323,
    cy: 70.782,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2438,
    fill: "#F1F1F2",
    enableBackground: "new    ",
    cx: 135.333,
    cy: 70.793,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2388,
    fill: "#F1F2F2",
    enableBackground: "new    ",
    cx: 135.342,
    cy: 70.805,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2338,
    fill: "#F1F2F2",
    enableBackground: "new    ",
    cx: 135.352,
    cy: 70.816,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2289,
    fill: "#F2F2F3",
    enableBackground: "new    ",
    cx: 135.361,
    cy: 70.827,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2239,
    fill: "#F2F2F3",
    enableBackground: "new    ",
    cx: 135.37,
    cy: 70.839,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2189,
    fill: "#F2F3F3",
    enableBackground: "new    ",
    cx: 135.38,
    cy: 70.85,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2139,
    fill: "#F3F3F3",
    enableBackground: "new    ",
    cx: 135.389,
    cy: 70.861,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.209,
    fill: "#F3F3F4",
    enableBackground: "new    ",
    cx: 135.399,
    cy: 70.873,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.204,
    fill: "#F3F4F4",
    enableBackground: "new    ",
    cx: 135.408,
    cy: 70.884,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.199,
    fill: "#F3F4F4",
    enableBackground: "new    ",
    cx: 135.417,
    cy: 70.895,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.194,
    fill: "#F4F4F5",
    enableBackground: "new    ",
    cx: 135.427,
    cy: 70.907,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1891,
    fill: "#F4F4F5",
    enableBackground: "new    ",
    cx: 135.436,
    cy: 70.918,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1841,
    fill: "#F4F5F5",
    enableBackground: "new    ",
    cx: 135.445,
    cy: 70.929,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1791,
    fill: "#F5F5F5",
    enableBackground: "new    ",
    cx: 135.455,
    cy: 70.94,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1741,
    fill: "#F5F5F6",
    enableBackground: "new    ",
    cx: 135.464,
    cy: 70.952,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1692,
    fill: "#F5F6F6",
    enableBackground: "new    ",
    cx: 135.474,
    cy: 70.963,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1642,
    fill: "#F5F6F6",
    enableBackground: "new    ",
    cx: 135.483,
    cy: 70.974,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1592,
    fill: "#F6F6F6",
    enableBackground: "new    ",
    cx: 135.492,
    cy: 70.986,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1542,
    fill: "#F6F6F7",
    enableBackground: "new    ",
    cx: 135.502,
    cy: 70.997,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1493,
    fill: "#F6F7F7",
    enableBackground: "new    ",
    cx: 135.511,
    cy: 71.008,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1443,
    fill: "#F7F7F7",
    enableBackground: "new    ",
    cx: 135.521,
    cy: 71.02,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1393,
    fill: "#F7F7F7",
    enableBackground: "new    ",
    cx: 135.53,
    cy: 71.031,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1343,
    fill: "#F7F7F8",
    enableBackground: "new    ",
    cx: 135.539,
    cy: 71.042,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1294,
    fill: "#F7F8F8",
    enableBackground: "new    ",
    cx: 135.549,
    cy: 71.054,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1244,
    fill: "#F8F8F8",
    enableBackground: "new    ",
    cx: 135.558,
    cy: 71.065,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1194,
    fill: "#F8F8F9",
    enableBackground: "new    ",
    cx: 135.567,
    cy: 71.076,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1144,
    fill: "#F8F9F9",
    enableBackground: "new    ",
    cx: 135.577,
    cy: 71.088,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1095,
    fill: "#F9F9F9",
    enableBackground: "new    ",
    cx: 135.586,
    cy: 71.099,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1045,
    fill: "#F9F9F9",
    enableBackground: "new    ",
    cx: 135.596,
    cy: 71.11,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.0995,
    fill: "#F9F9FA",
    enableBackground: "new    ",
    cx: 135.605,
    cy: 71.122,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.0945,
    fill: "#FAFAFA",
    enableBackground: "new    ",
    cx: 135.614,
    cy: 71.133,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.0896,
    fill: "#FAFAFA",
    enableBackground: "new    ",
    cx: 135.624,
    cy: 71.144,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.0846,
    fill: "#FAFAFA",
    enableBackground: "new    ",
    cx: 135.633,
    cy: 71.155,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.0796,
    fill: "#FAFBFB",
    enableBackground: "new    ",
    cx: 135.643,
    cy: 71.167,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.0746,
    fill: "#FBFBFB",
    enableBackground: "new    ",
    cx: 135.652,
    cy: 71.178,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.0697,
    fill: "#FBFBFB",
    enableBackground: "new    ",
    cx: 135.661,
    cy: 71.189,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.0647,
    fill: "#FBFBFC",
    enableBackground: "new    ",
    cx: 135.671,
    cy: 71.201,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.0597,
    fill: "#FCFCFC",
    enableBackground: "new    ",
    cx: 135.68,
    cy: 71.212,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.0547,
    fill: "#FCFCFC",
    enableBackground: "new    ",
    cx: 135.689,
    cy: 71.223,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.0498,
    fill: "#FCFCFC",
    enableBackground: "new    ",
    cx: 135.699,
    cy: 71.235,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.0448,
    fill: "#FCFCFD",
    enableBackground: "new    ",
    cx: 135.708,
    cy: 71.246,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.0398,
    fill: "#FDFDFD",
    enableBackground: "new    ",
    cx: 135.718,
    cy: 71.257,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.0348,
    fill: "#FDFDFD",
    enableBackground: "new    ",
    cx: 135.727,
    cy: 71.269,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.0299,
    fill: "#FDFDFD",
    enableBackground: "new    ",
    cx: 135.736,
    cy: 71.28,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.0249,
    fill: "#FEFEFE",
    enableBackground: "new    ",
    cx: 135.746,
    cy: 71.291,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.0199,
    fill: "#FEFEFE",
    enableBackground: "new    ",
    cx: 135.755,
    cy: 71.303,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.0149,
    fill: "#FEFEFE",
    enableBackground: "new    ",
    cx: 135.765,
    cy: 71.314,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.01,
    fill: "#FEFEFE",
    enableBackground: "new    ",
    cx: 135.774,
    cy: 71.325,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.005,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    cx: 135.783,
    cy: 71.337,
    r: 19.659
  }), /*#__PURE__*/React.createElement("circle", {
    id: "BlendTop",
    fill: "#FFFFFF",
    fillOpacity: 0,
    cx: 135.793,
    cy: 71.348,
    r: 19.659
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Registered",
    clipPath: "url(#SVGID_2_)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M241.432,49.275c0-0.648-0.446-1.002-1.23-1.002h-1.043v3.248h0.775v-1.26l0.909,1.26h0.946l-1.068-1.339 C241.18,50.059,241.432,49.726,241.432,49.275z M240.066,49.719h-0.131V48.87h0.139c0.383,0,0.583,0.138,0.583,0.418 C240.657,49.574,240.455,49.719,240.066,49.719z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M240.359,47.06c-1.577,0-2.829,1.258-2.829,2.831c0,1.572,1.266,2.832,2.829,2.832 c1.536,0,2.795-1.274,2.795-2.832C243.154,48.34,241.895,47.06,240.359,47.06z M240.347,52.217c-1.241,0-2.256-1.033-2.256-2.322 c0-1.293,1.002-2.325,2.256-2.325c1.235,0,2.242,1.056,2.242,2.325C242.589,51.173,241.583,52.217,240.347,52.217z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/discover.964c4bed6a2383fdfb6e22dcf3449ded.svg";
export { ForwardRef as ReactComponent };